import { Environment } from './index';

export const environment: Environment = {
  production: false,
  apiEndpoint: 'https://api.public.dev.otaportal.cimbaligroup.tech',
  cognito: {
    userPoolId: 'eu-west-1_IG4ZSYkpy',
    userPoolWebClientId: '44hn6v94n0ie4t1dua3vm5ehas',
    region: 'eu-west-1',
    groups: {
      globalAdmin: 'dev-ota-portal-global-admin-user-pool-group',
      technician: 'dev-ota-portal-technician-user-pool-group',
      technicianAdmin: 'dev-ota-portal-technician-admin-user-pool-group',
      swDeveloper: 'dev-ota-portal-sw-developer-user-pool-group',
      swManager: 'dev-ota-portal-sw-manager-user-pool-group',
      pendingUser: 'dev-ota-portal-pending-user-pool-group',
    },
  },
};
